import React, { useEffect, useState } from "react";
import "./Categories.css";
import Breadcrumb_comp from "../common-components/breadcrumb-comp/Breadcrumb_comp";
import Common_Heading_Round_holder from "../common-components/common_Heading_Round_holder/Common_Heading_Round_holder";
import Product_card from "../common-components/product_card/Product_card";
import Green_round_btn from "../common-components/common_btn/green_round_btn/Green_round_btn";
import Stay_Connected from "../home/stay_Connected/Stay_Connected";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCategories,
  getAllSubCategory,
  getAllChildCategory,
} from "../../features/master/masterSlice";
import {
  getAllProducts,
  getGroupByProduct,
} from "../../features/products/productsSlice";
import Product_Info_Card from "../common-components/product_info_card/Product_Info_Card";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import Category_Subcategory_Card from "../common-components/category_subcategory_card/Category_Subcategory_Card";
import { variant_type } from "../../utils/common";
import Common_heading_holder from "../common-components/common_heading_holder/Common_heading_holder";
import No_data from "../common-components/No_data/No_data";

const STEP = 4;

function ChildSubCategories() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const categoryId = queryParams.get("category_id");
  const dispatch = useDispatch();
  const app_setup = useSelector((state) => state.master.app_setup);
  const [swiperInstance, setSwiperInstance] = useState(null);
  const subCategoryId = queryParams.get("sub_category_id");
  const childCategoryId = queryParams.get("child_category_id");
  const handleToggle = (index, totalProducts, categoryId) => {
    setVisibleCounts((prevCounts) => {
      const newCounts = prevCounts.map((count, i) =>
        i === index
          ? count >= totalProducts
            ? STEP
            : Math.min(count + STEP, totalProducts)
          : count,
      );

      // Scroll if reducing to STEP
      if (prevCounts[index] >= totalProducts) {
        const el = document.getElementById(categoryId);
        if (el) {
          setTimeout(() => {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
          }, 100); // delay to ensure layout update
        }
      }

      return newCounts;
    });
  };

  useEffect(() => {
    const scrollToId = location.state?.scrollToId;
    if (scrollToId) {
      const scroll = () => {
        const element = document.getElementById(scrollToId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          setTimeout(scroll, 100);
        }
      };
      scroll();
    }
  }, [location.state]);
  const childcategories = useSelector((state) => state.master.childcategories);

  useEffect(() => {
    if (!subCategoryId || subCategoryId === "undefined") return;

    const subId = Number(subCategoryId);

    dispatch(getAllChildCategory({ sub_category_id: subId }));
  }, [subCategoryId]);

  const [visibleCounts, setVisibleCounts] = useState([]);
  const [selectedChildCategoryId, setSelectedChildCategoryId] = useState("");

  useEffect(() => {
    if (childcategories?.length > 0) {
      setSelectedChildCategoryId(childcategories[0]?.id);
    }
  }, [childcategories]);

  // Scroll to a specific category section when "See Less" is clicked

  const category = useSelector((state) => state.master.categories);
  const subcategories = useSelector((state) => state?.master?.subcategories);
  const all_products = useSelector((state) => state.product.allProducts);

  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [childList, setChildList] = useState([]);
  const [childStatus, setChildStatus] = useState(""); // noChild

  useEffect(() => {
    if (childcategories?.length > 0) {
      if (!selectedChildCategoryId) return;
    }
    dispatch(
      getAllProducts({
        subcategory_id: subCategoryId || "",
        childcategory_id: selectedChildCategoryId || "",
      }),
    );
  }, [selectedChildCategoryId, subCategoryId]);

  useEffect(() => {
    if (!categoryId) return;

    dispatch(
      getAllSubCategory({
        category_id: categoryId,
      }),
    );
  }, [categoryId]);

  const handleSubCategoryClick = (categoryId, subId) => {
    setSelectedCategoryId(categoryId);
    setSelectedSubCategory(subId);

    // Find the clicked subcategory
    const selected = subcategories.find((s) => s.id === subId);

    // Populate child list
    if (!selected || !selected.children || selected.children.length === 0) {
      setChildList([]);
      setChildStatus("noChild");
    } else {
      setChildList(selected.children);
      setChildStatus("");
    }

    // Load products
    dispatch(
      getAllProducts({
        // category_id: categoryId,
        sub_category_id: subId,
      }),
    );
  };

  const [selectedCategoryId, setSelectedCategoryId] = useState("");

  const [status, setStatus] = useState("");

  const selectedCategory = category?.find(
    (item) => Number(item.id) === Number(categoryId),
  );

  const selectedSubCategoryData = subcategories?.find(
    (item) => Number(item.id) === Number(subCategoryId),
  );

  const selectedChildCategory = childcategories?.find(
    (item) => Number(item.id) === Number(selectedChildCategoryId),
  );

  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: selectedCategory?.name, link: "", isActive: true },
    { label: selectedSubCategoryData?.name, link: "", isActive: true },
    { label: selectedChildCategory?.name, link: "", isActive: true },

    // ...(selectedCategory
    //   ? [
    //       {
    //         label: selectedCategory?.name,
    //         link: "",
    //         isActive: false,
    //       },
    //     ]
    //   : []),

    // ...(selectedSubCategoryData
    //   ? [
    //       {
    //         label: selectedSubCategoryData?.name,
    //         link: "",
    //         isActive: false,
    //         // isActive: !selectedChildCategory,
    //       },
    //     ]
    //   : []),

    // ...(selectedChildCategory
    //   ? [
    //       {
    //         label: selectedChildCategory?.name,
    //         link: "",
    //         isActive: false,
    //       },
    //     ]
    //   : []),
  ];

  return (
    <section className="Categories_section_holder">
      {/* {childcategories?.length <= 0 ? (
        <></>
      ) : ( */}
      {/* // <div className="text-center mt-4">
        //   <No_data />
        //   <p>No products found for this Sub category</p>
        // </div> */}
      <div className="container-fluid">
        <div className="Categories">
          <div className="breadcrump_div">
            <Breadcrumb_comp breadcrumbs={breadcrumbs} />
          </div>

          {/* new code for subcategories */}
          {childcategories?.length > 0 && (
            <Common_heading_holder
              heading_text={
                <>
                  <span className="black-text">Explore </span>
                  <br />
                  <span className="blue-text">Collection</span>
                </>
              }
            />
          )}

          <div className="cat_subcat_div">
            {childcategories?.length <= 0 ? (
              <></>
            ) : (
              // <p className="text-danger">
              //   <div>
              //     <No_data />
              //   </div>{" "}
              //   No child category available.
              // </p>
              <div variant="pills" className="flex-row p-0 mb-3">
                <Swiper
                  className="mySwiper "
                  pagination={{
                    dynamicBullets: true,
                    clickable: true,
                  }}
                  modules={[Pagination]}
                  breakpoints={{
                    0: { slidesPerView: 3, spaceBetween: 10 },
                    350: { slidesPerView: 4, spaceBetween: 10 },
                    576: { slidesPerView: 4, spaceBetween: 10 },
                    768: { slidesPerView: 5, spaceBetween: 10 },
                    992: { slidesPerView: 6, spaceBetween: 10 },
                    1200: { slidesPerView: 8, spaceBetween: 10 },
                  }}
                >
                  {/* <SwiperSlide key={0} className="product-slide">
                    <Nav.Item>
                      <Nav.Link
                        eventKey=""
                        onClick={() => {
                          setSelectedChildCategoryId(""); //IMPORTANT
                        }}
                      >
                        <Category_Subcategory_Card
                          activeClassName={
                            selectedChildCategoryId === ""
                              ? "activecategory"
                              : ""
                          }
                          // activeClassName={
                          //   category_Id
                          //     ? Number(category_Id) === Number(slide?.id)
                          //       ? "activecategory"
                          //       : ""
                          //     : selectedCategoryId === slide?.id
                          //     ? "activecategory"
                          //     : ""
                          // }
                          className="product-image"
                          content="All Child Sub Categories"
                          image={
                            process.env.REACT_APP_IMG_URL + app_setup?.qr_image
                          }
                          imgClassName="category-image"
                        />
                        <div className="triangle-right"></div>
                      </Nav.Link>
                    </Nav.Item>
                  </SwiperSlide> */}
                  {childcategories?.map((slide, index) => (
                    <SwiperSlide key={index} className="product-slide">
                      <Nav.Item>
                        <Nav.Link
                          eventKey={slide?.id}
                          onClick={() => {
                            setSelectedChildCategoryId(slide.id);
                          }}
                        >
                          <Category_Subcategory_Card
                            activeClassName={
                              Number(selectedChildCategoryId) ===
                              Number(slide?.id)
                                ? "activecategory"
                                : ""
                            }
                            // activeClassName={
                            //   category_Id
                            //     ? Number(category_Id) === Number(slide?.id)
                            //       ? "activecategory"
                            //       : ""
                            //     : selectedCategoryId === slide?.id
                            //     ? "activecategory"
                            //     : ""
                            // }
                            className="product-image"
                            content={slide?.name}
                            image={process.env.REACT_APP_IMG_URL + slide?.image}
                            imgClassName="category-image"
                          />
                          <div className="triangle-right"></div>
                        </Nav.Link>
                      </Nav.Item>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            )}
          </div>

          {all_products?.data?.length <= 0 ? (
            <>
              <div className="text-center mt-4">
                <No_data />

                <p className="text-danger mt-2">
                  No products available for this selection.
                </p>
              </div>
            </>
          ) : (
            <>
              <Common_heading_holder
                heading_text={
                  <>
                    <span className="black-text">Discover </span>
                    <br />
                    <span className="blue-text">Products</span>
                  </>
                }
              />

              {/* Child cat products */}

              <div className="row">
                {all_products?.data?.length > 0 ? (
                  all_products.data.map((product, index) => {
                    let metal = null;
                    let size = null;
                    let triple = null;

                    if (
                      Number(product?.variant_type_id) ===
                      Number(variant_type.Single)
                    ) {
                      metal = product?.Product_Variants?.[0];
                    } else if (
                      Number(product?.variant_type_id) ===
                      Number(variant_type.Double)
                    ) {
                      metal = product?.Product_Variants?.[0];
                      size = metal?.Double_Variants?.[0];
                    } else if (
                      Number(product?.variant_type_id) ===
                      Number(variant_type.Triple)
                    ) {
                      metal = product?.Product_Variants?.[0];
                      size = metal?.Double_Variants?.[0];
                      triple = size?.Triple_Variants?.[0];
                    }

                    const activeVariant = triple || size || metal || {};

                    return (
                      <div
                        className="col-lg-4 col-md-4 col-sm-6 col-6 px-md-2 px-1 custom_5_col"
                        key={product?.id || index}
                      >
                        <Product_Info_Card
                          product={product}
                          id={product?.id}
                          imgSrc={
                            product?.image
                              ? process.env.REACT_APP_IMG_URL + product.image
                              : ""
                          }
                          vdoSrc={
                            product?.video
                              ? process.env.REACT_APP_IMG_URL + product.video
                              : ""
                          }
                          productName={product?.name || ""}
                          mrp={activeVariant?.mrp || 0}
                          priceText={activeVariant?.price || 0}
                          kgText={activeVariant?.name || ""}
                          savingPrice={
                            Number(activeVariant?.mrp || 0) -
                            Number(activeVariant?.price || 0)
                          }
                        />
                      </div>
                    );
                  })
                ) : (
                  <div className="text-center mt-4">
                    <No_data />
                    <p>No products Available</p>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
      {/* )} */}
    </section>
  );
}

export default ChildSubCategories;
